<template>
  <div class="director-page">
    <section class="profile-hero">
      <div class="profile-inner">
        <div class="profile-main">
          <div class="profile-copy">
            <div class="profile-name-row">
              <span class="level-badge">HR</span>
              <h1 v-if="personalData.enterprise_name">{{ personalData.enterprise_name }}</h1>
              <h1 v-else>HR 專區</h1>
              <span class="profile-subtitle">企業管理後台</span>
            </div>
          </div>
        </div>

        <div class="profile-stats">
          <label class="stat-card stat-select">
            <span>班級</span>
            <select v-model="selected">
              <option v-for="(item, index) in groupList" :key="index" :value="item.id">
                {{ item.name }}
              </option>
            </select>
          </label>
          <div class="stat-card">
            <span>學生數</span>
            <strong>{{ groupInfo.student_count ? groupInfo.student_count : 0 }}</strong>
          </div>
          <div class="stat-card">
            <span>課程時間</span>
            <strong class="date-range" v-if="groupInfo.begin_at && groupInfo.end_at">
              {{ moment(groupInfo.begin_at).format('YYYY/MM/DD') }} - {{ moment(groupInfo.end_at).format('YYYY/MM/DD') }}
            </strong>
            <strong class="date-range" v-else>-</strong>
          </div>
        </div>
      </div>
    </section>

    <nav class="personal-tabs">
      <div class="tabs-inner">
        <button type="button" @click="goPage('Overview')" :class="{ active: $route.name === 'Overview' }">班級總覽</button>
        <button type="button" @click="goPage('PersonalDetail')" :class="{ active: $route.name === 'PersonalDetail' }">個人學習資料</button>
      </div>
    </nav>

    <main class="director-content">
      <router-view :standard="standard" :groupId="selected"></router-view>
    </main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '../../store/api'

export default {
  name: 'Director',
  data () {
    return {
      selected: this.$route.params.groupId,
      personalData: {},
      enterpriseId: 0,
      standard: '',
      groupList: [],
      groupInfo: {}
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  watch: {
    selected (val) {
      this.getGroupInfo(val)
      this.$router.push({ params: { groupId: val } })
    }
  },
  mounted() {
    this.scrollTop()
    this.getPersonalData()
  },
  methods: {
    goPage (el) {
      switch (el) {
        case 'Overview':
          this.$router.push({ name: el, params: { type: 'summary', groupId: this.selected } })
          break
        case 'PersonalDetail':
          this.$router.push({ name: el, params: { groupId: this.selected } })
          break
      }
    },
    async getTarget (id) {
      const { data } = await api.get(`/records/students/${id}/learning_progress`)
      this.target = data.data
      this.target.segment = this.segment
      this.target.standard = this.personalData.enterprise_standard
    },
    getPersonalData () {
      this.personalData = this.userInfo
      this.enterpriseId = this.userInfo.enterprise_id
      this.getGroupList(this.userInfo.enterprise_id)
    },
    async getGroupList (id) {
      const { data } = await api.get(`/enterprises/${id}/groups?pageSize=100000`)
      this.groupList = data.data
      this.getGroupInfo(this.selected)
    },
    async getGroupInfo (id) {
      const { data } = await api.get(`/groups/${id}`)
      this.groupInfo = data.data
      this.standard = data.data.enterprise_standard
    },
    scrollTop () {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.director-page {
  min-height: calc(100vh - 93px);
  background: #f4f7fa;
}

.profile-hero {
  min-height: 250px;
  height: 30vh;
  background-image: url('../../assets/image/pic/bg_member_top.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.profile-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  max-width: 1100px;
  min-height: 250px;
  height: 100%;
  margin: 0 auto;
  padding: 32px 0;
}

.profile-main {
  display: flex;
  align-items: center;
  min-width: 0;
}

.profile-copy {
  min-width: 0;
  color: #fff;
  text-align: left;
}

.profile-name-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 14px;
}

.level-badge {
  min-width: 42px;
  padding: 4px 10px;
  color: #08294a;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.2;
  text-align: center;
  background: #f5c425;
  border-radius: 2px;
}

.profile-name-row h1 {
  margin: 0;
  color: #fff;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

.profile-subtitle {
  color: rgba(255, 255, 255, .76);
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.profile-meta {
  display: flex;
  gap: 24px;
  flex-wrap: nowrap;
  color: rgba(255, 255, 255, .76);
  font-size: 12px;
}

.profile-meta span {
  white-space: nowrap;
}

.profile-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
  flex: 0 0 560px;
}

.stat-card {
  min-height: 86px;
  padding: 16px 20px;
  text-align: left;
  background: rgba(255, 255, 255, .08);
  border: 1px solid rgba(255, 255, 255, .22);
  border-radius: 5px;
}

.stat-card span {
  display: block;
  margin-bottom: 9px;
  color: rgba(255, 255, 255, .52);
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.stat-card strong {
  display: block;
  color: #fff;
  font-size: 24px;
  line-height: 1.2;
  white-space: nowrap;
}

.stat-card .date-range {
  font-size: 14px;
  line-height: 1.5;
}

.stat-select {
  margin: 0;
}

.stat-select select {
  width: 100%;
  min-height: 34px;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  background: transparent;
  border: 0;
  border-bottom: 1px solid rgba(255, 255, 255, .35);
  outline: 0;
}

.stat-select option {
  color: #173b55;
}

.personal-tabs {
  background: #fff;
  border-bottom: 1px solid #d7e0e8;
}

.tabs-inner {
  display: flex;
  gap: 30px;
  max-width: 1100px;
  height: 64px;
  margin: 0 auto;
  overflow-x: auto;
}

.tabs-inner button {
  position: relative;
  padding: 0 0 3px;
  color: #85a0b5;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  background: transparent;
  border: 0;
}

.tabs-inner button.active {
  color: #113b5a;
}

.tabs-inner button.active::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3px;
  background: #f5a623;
}

.director-content {
  max-width: 1100px;
  margin: 0 auto;
}

@media (max-width: 1199px) {
  .profile-inner,
  .tabs-inner,
  .director-content {
    max-width: none;
    margin-left: 24px;
    margin-right: 24px;
  }
}

@media (max-width: 991px) {
  .profile-inner {
    align-items: flex-start;
    flex-direction: column;
    gap: 22px;
  }

  .profile-stats {
    width: 100%;
    flex-basis: auto;
  }

  .profile-meta {
    flex-wrap: wrap;
  }
}

@media (max-width: 767px) {
  .profile-hero {
    height: auto;
  }

  .profile-inner,
  .tabs-inner,
  .director-content {
    margin-left: 16px;
    margin-right: 16px;
  }

  .profile-name-row h1 {
    font-size: 24px;
  }

  .profile-stats {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .profile-meta {
    flex-wrap: wrap;
    gap: 8px;
  }

  .tabs-inner {
    gap: 22px;
    height: 56px;
  }
}
</style>
